import { signInWithEmailAndPassword, signOut } from "firebase/auth";
import { doc, getDoc, collection, setDoc } from "firebase/firestore";

import { Utils } from "utils";
import { db, auth } from "configs";
import { Iterable, IAdmin } from "types";
import { COLLECTIONS } from "constants/firebase";

export const login = (email: string, password: string) => {
  return signInWithEmailAndPassword(auth, email, password);
};

export const get = async (id: string) => {
  const ref = doc(db, COLLECTIONS.ADMINS, id);
  const response = await getDoc(ref);

  const document = response.exists()
    ? Utils.Helpers.castDoc<Iterable<IAdmin>>(response)
    : undefined;

  return Promise.resolve(document);
};

export const update = (id: string, data: any) => {
  const collectionRef = collection(db, COLLECTIONS.ADMINS);
  const document = doc(collectionRef, id);
  return setDoc(document, data, { merge: true });
};

export const logout = () => signOut(auth);
